import { ReactComponent as SvgAlgorand } from './Algorand.svg.es.js';
import { ReactComponent as SvgAptos } from './Aptos.svg.es.js';
import { ReactComponent as SvgArbitrum } from './Arbitrum.svg.es.js';
import { ReactComponent as SvgAvalanche } from './Avalanche.svg.es.js';
import { ReactComponent as SvgBase } from './BASE.svg.es.js';
import { ReactComponent as SvgBinanceSmartChain } from './BinanceSmartChain.svg.es.js';
import { ReactComponent as SvgBitcoin } from './Bitcoin.svg.es.js';
import { ReactComponent as SvgCardano } from './Cardano.svg.es.js';
import { ReactComponent as SvgCelo } from './Celo.svg.es.js';
import { ReactComponent as SvgCodex } from './Codex.svg.es.js';
import { ReactComponent as SvgEos } from './EOS.svg.es.js';
import { ReactComponent as SvgEvm } from './EVM.svg.es.js';
import { ReactComponent as SvgEvmTestnet } from './EVMTestnet.svg.es.js';
import { ReactComponent as SvgEthereum } from './Ethereum.svg.es.js';
import { ReactComponent as SvgFlow } from './Flow.svg.es.js';
import { ReactComponent as SvgHederaHashgraph } from './HederaHashgraph.svg.es.js';
import { ReactComponent as SvgLinea } from './Linea.svg.es.js';
import { ReactComponent as SvgNear } from './NEAR.svg.es.js';
import { ReactComponent as SvgNeo } from './NEO.svg.es.js';
import { ReactComponent as SvgNoble } from './Noble.svg.es.js';
import { ReactComponent as SvgOptimism } from './Optimism.svg.es.js';
import { ReactComponent as SvgParachain } from './Parachain.svg.es.js';
import { ReactComponent as SvgPolkadot } from './Polkadot.svg.es.js';
import { ReactComponent as SvgPolygon } from './Polygon.svg.es.js';
import { ReactComponent as SvgSettlus } from './Settlus.svg.es.js';
import { ReactComponent as SvgSolana } from './Solana.svg.es.js';
import { ReactComponent as SvgStellar } from './Stellar.svg.es.js';
import { ReactComponent as SvgSui } from './Sui.svg.es.js';
import { ReactComponent as SvgTron } from './Tron.svg.es.js';
import { ReactComponent as SvgUnichain } from './Unichain.svg.es.js';
import { ReactComponent as SvgUnichainTestnet } from './UnichainTestnet.svg.es.js';
import { ReactComponent as SvgXrpl } from './XRPL.svg.es.js';

const SvgBlockchainIcons = {
    'Blockchain/Algorand': SvgAlgorand,
    'Blockchain/Aptos': SvgAptos,
    'Blockchain/Arbitrum': SvgArbitrum,
    'Blockchain/Avalanche': SvgAvalanche,
    'Blockchain/BASE': SvgBase,
    'Blockchain/BinanceSmartChain': SvgBinanceSmartChain,
    'Blockchain/Bitcoin': SvgBitcoin,
    'Blockchain/Cardano': SvgCardano,
    'Blockchain/Celo': SvgCelo,
    'Blockchain/Codex': SvgCodex,
    'Blockchain/EOS': SvgEos,
    'Blockchain/Ethereum': SvgEthereum,
    'Blockchain/EVM': SvgEvm,
    'Blockchain/EVMTestnet': SvgEvmTestnet,
    'Blockchain/Flow': SvgFlow,
    'Blockchain/HederaHashgraph': SvgHederaHashgraph,
    'Blockchain/Linea': SvgLinea,
    'Blockchain/NEAR': SvgNear,
    'Blockchain/NEO': SvgNeo,
    'Blockchain/Noble': SvgNoble,
    'Blockchain/Optimism': SvgOptimism,
    'Blockchain/Parachain': SvgParachain,
    'Blockchain/Polkadot': SvgPolkadot,
    'Blockchain/Polygon': SvgPolygon,
    'Blockchain/XRPL': SvgXrpl,
    'Blockchain/Settlus': SvgSettlus,
    'Blockchain/Solana': SvgSolana,
    'Blockchain/Stellar': SvgStellar,
    'Blockchain/Sui': SvgSui,
    'Blockchain/Tron': SvgTron,
    'Blockchain/Unichain': SvgUnichain,
    'Blockchain/UnichainTestnet': SvgUnichainTestnet
};

export { SvgBlockchainIcons };
//# sourceMappingURL=index.es.js.map
